"use strict";
exports.__esModule = true;
exports.ErrorWithMessage = void 0;
/**
 * ConnectError
 */
var ErrorWithMessage = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param message
     */
    function ErrorWithMessage(message) {
        this.message = message;
    }
    return ErrorWithMessage;
}());
exports.ErrorWithMessage = ErrorWithMessage;
